import { apiRequest } from "./client";
import type { EntityRelationDto, RelationGroupDto } from "./types";

export type AddRelationPayload = {
	fromEntityId: string;
	toEntityId: string;
	relationType: string;
	/** Marks the relation as former (e.g. ex-wife); only valid for types that can end. */
	isEx?: boolean;
};

/** Creates a relation "from is <relationType> of to"; the backend mirrors the inverse automatically. */
export const addRelation = (payload: AddRelationPayload, token: string): Promise<void> =>
	apiRequest<void>("/relations", { method: "POST", body: payload, token });

/** Relation types grouped by context (Family, Places & Geography, …), in display order. */
export const getRelationGroups = (token: string): Promise<RelationGroupDto[]> =>
	apiRequest<RelationGroupDto[]>("/relations/groups", { token });

export const getEntityRelations = (entityId: string, token: string): Promise<EntityRelationDto[]> =>
	apiRequest<EntityRelationDto[]>(`/entities/${entityId}/relations`, { token });

/** Removes a relation and its mirrored inverse. */
export const removeRelation = (relationId: string, token: string): Promise<void> =>
	apiRequest<void>(`/relations/${relationId}`, { method: "DELETE", token });
